import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SELFSERVICE_SUPABASE_URL as string | undefined;
const anon = import.meta.env.VITE_SELFSERVICE_SUPABASE_ANON_KEY as string | undefined;

export const isSelfServiceConfigured = Boolean(url && anon);

// `persistSession: true` turns the Supabase client into the source of truth
// for auth state across tabs and reloads. The selfservice-api reads the
// returned access_token to identify the caller; useAuth + apiClient consume
// the same client.
export const selfServiceSupabase = isSelfServiceConfigured
  ? createClient(url!, anon!, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;
